import { updateSectionData } from '../handlers/utils';

/**
 *
 * @param formData
 * @param navSectionObj
 * @param sectionObj
 * @param questions
 * @param questionsAr
 * @returns {*}
 */
export const setQuestions = (formData, navSectionObj, sectionObj, questions, questionsAr) => {
  questions.forEach((question) => {
    if (question.question_type !== 'multipart') {
      if (formData[sectionObj.slug]) {
        for (let i = 0; i < formData[sectionObj.slug].length; i++) {
          questionsAr[i] = Array.isArray(questionsAr[i]) ? questionsAr[i] : [];
          const answers = formData[sectionObj.slug][i];
          dance:
            if(answers !== null) {
              for (const [aqid, answer] of Object.entries(answers)) {
                if (aqid === question.qid) {
                  const qidObj = typeof sectionObj[question.qid] === 'undefined' ? {} : sectionObj[question.qid];
                  qidObj.text = question.question;
                  qidObj.answer = answer;
                  questionsAr[i][question.qid] = typeof questionsAr[i][question.qid] === 'undefined' ? qidObj : questionsAr[i][question.qid];
                  break dance;
                }
              }
            }
        }
      }
    } else {
      let multiPartQuestions = [];
      //assuming that if a question (sectionObj.questions) is a multipart
      //then question_parts (sectionObj.question_parts) exist
      for (let j = 0; j < navSectionObj.question_parts.length; j++) {
        const question_part = navSectionObj.question_parts[j];
        if (question_part.mpparent === question.qid) {
          multiPartQuestions.push(question_part);
        }
      }
      questionsAr = setQuestions(formData, navSectionObj, sectionObj, multiPartQuestions, questionsAr);
    }
  });
  return questionsAr;
};

/**
 *
 * @param stateProps
 * @param formikProps
 */
export const resetParse = (stateProps,formikProps,) => {
  /*
  let parsed = false;
  let sectionName = stateProps.sectionData.sectionName;
  if(stateProps.sectionData.parsed) {
    parsed=false;
  } else {
    parsed=true;
    sectionName = 'parser';
  };*/

  const resumeIndex = stateProps.sectionData.resumeIndex;
  const resume = stateProps.dataToSave.saved.resumes[resumeIndex];
  resume.parsed = false;
  updateSectionData({parsed:false,sectionName:'parser'},stateProps);
}
/**
 *
 * @param formData
 * @param navSections
 * @returns {{}}
 */
export const getPreviews = (formData, navSections) => {
  let previews = {};
  for (const [sectionSlug, navSectionObj] of Object.entries(navSections)) {
    const sectionObj = typeof previews[sectionSlug] === 'undefined' ? {} : previews[sectionSlug];
    previews[sectionSlug] = sectionObj;
    sectionObj.label = navSectionObj.label;
    sectionObj.slug = sectionSlug;
    sectionObj['questions'] = setQuestions(formData, navSectionObj, sectionObj, navSectionObj.questions, []);
  }
  return previews;
};